export const ROUTES = {
  MONEY_SAVED_HOME: "/money-saved",
};

export interface Achievement {
  id: number;
  name: string;
  icon: string;
  threshold: number;
  unlocked: boolean;
  date: string | null;
}

export const ACHIEVEMENT_DEFINITIONS: Omit<Achievement, "unlocked" | "date">[] =
  [
    { id: 1, name: "First $1K Saved", icon: "🎯", threshold: 1000 },
    { id: 2, name: "Ad Spend Optimizer", icon: "📊", threshold: 5000 },
    { id: 3, name: "$10K Milestone", icon: "💰", threshold: 10000 },
    { id: 4, name: "$50K Club", icon: "💎", threshold: 50000 },
    { id: 5, name: "$100K Milestone", icon: "🏆", threshold: 100000 },
    { id: 6, name: "$200K Legend", icon: "👑", threshold: 200000 },
  ];

export function getAchievements(totalSavings: number): Achievement[] {
  return ACHIEVEMENT_DEFINITIONS.map((def) => ({
    ...def,
    unlocked: totalSavings >= def.threshold,
    date: totalSavings >= def.threshold ? "Unlocked" : null,
  }));
}
